<template>
    <div class="right_box_main">
        <!-- 面包屑导航 -->
        <div class="mianbao">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }"
                    >首页</el-breadcrumb-item
                >
                <el-breadcrumb-item>智慧协商</el-breadcrumb-item>
                <el-breadcrumb-item>人员信息库</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-box">
            <!-- 右边卡片 -->
            <div class="card-rb">
                <div class="card-4">
                    <el-card :body-style="{ padding: '16px' }">
                        <div class="fisthang">
                            <el-form
                                :inline="true"
                                :model="searchlist"
                                class="demo-form-inline"
                                size="mini"
                            >
                                <el-form-item
                                    label="姓名:"
                                    style="margin: 0 30 0 0"
                                >
                                    <el-input
                                        v-model="searchlist.name"
                                        placeholder="请输入姓名"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="审批状态:"
                                    style="margin: 0 30 0 0"
                                >
                                    <el-radio-group
                                        v-model="searchlist.approvalStatus"
                                    >
                                        <el-radio label="0">待审批</el-radio>
                                        <el-radio label="1">同意</el-radio>
                                        <el-radio label="2">不同意</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item
                                    ><el-button
                                        type="success"
                                        size="mini"
                                        @click="showDialogForm('', 'add')"
                                        >新增</el-button
                                    ></el-form-item
                                >
                                <el-form-item>
                                    <el-button
                                        type="primary"
                                        @click="searchlistdata"
                                        >查询</el-button
                                    >
                                </el-form-item>
                                <el-form-item>
                                    <el-button
                                        type="info"
                                        @click="searchlistReset"
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>
                        <!-- 表格盒子 -->
                        <div class="table_card">
                            <el-table
                                :data="tableData"
                                :header-cell-style="{ background: '#f8fafa' }"
                                border
                                align="center"
                                current-row-key
                                highlight-current-row
                            >
                                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                                <el-table-column
                                    type="index"
                                    align="center"
                                    label="序号"
                                    width="50"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="name"
                                    width="180"
                                    label="姓名"
                                ></el-table-column>
                                <el-table-column
                                    width="90"
                                    align="center"
                                    prop="sex"
                                    label="性别"
                                >
                                    <template scope="scope">
                                        <span v-if="scope.row.sex == 0"
                                            >男</span
                                        >
                                        <span v-if="scope.row.sex == 1"
                                            >女</span
                                        >
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="phone"
                                    width="180"
                                    label="手机号"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    width="380"
                                    prop="parentPersonTypeName"
                                    label="类别"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="consultOrgName"
                                    label="所属组织"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="createDate"
                                    label="创建时间"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="approvalStatus"
                                    label="审批状态"
                                    width="130"
                                >
                                    <template scope="scope">
                                        <span
                                            class="tab"
                                            :class="{
                                                active_tab2:
                                                    scope.row.approvalStatus ==
                                                    '1',
                                                active_tab1:
                                                    scope.row.approvalStatus ==
                                                    '0',
                                                active_tab:
                                                    scope.row.approvalStatus ==
                                                    '2',
                                            }"
                                            >{{
                                                scope.row.approvalStatus == "1"
                                                    ? "同意"
                                                    : scope.row
                                                          .approvalStatus == "2"
                                                    ? "不同意"
                                                    : "待审批"
                                            }}</span
                                        >
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="status"
                                    label="状态"
                                    width="150px"
                                >
                                    <template scope="scope">
                                        <el-switch
                                            v-model="scope.row.status"
                                            active-value="0"
                                            inactive-value="1"
                                            @change="changeStatus(scope.row)"
                                        ></el-switch>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    label="操作"
                                    width="210"
                                    fixed="right"
                                >
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="查看"
                                            placement="top-start"
                                            style="color: green"
                                        >
                                            <button
                                                class="iconfont icon-chakan tabBtn"
                                                @click="
                                                    showDialogForm(
                                                        scope.row.id,
                                                        'detail'
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            v-if="scope.row.editButtonFlag == 1"
                                            class="item"
                                            effect="light"
                                            content="编辑"
                                            style="color: blue"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-bianji3 tabBtn"
                                                @click="
                                                    showDialogForm(
                                                        scope.row.id,
                                                        'edit'
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="删除"
                                            style="color: red"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-icon7 tabBtn"
                                                @click="
                                                    showdeletepanduan(
                                                        scope.row.id
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            v-if="
                                                scope.row.auditButtonFlag == '1'
                                            "
                                            class="item"
                                            effect="light"
                                            content="审批"
                                            placement="top-start"
                                            style="fontweight: bold"
                                        >
                                            <button
                                                class="iconfont icon-shenhe tabBtn"
                                                @click="
                                                    showDialogForm(
                                                        scope.row.id,
                                                        'audit'
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageConfig.pageNo"
                                :page-sizes="[10, 20, 30, 50]"
                                :page-size="pageConfig.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="pageConfig.total"
                            ></el-pagination>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>
        <!-- 弹出框新增/修改/查看 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="showadd"
            width="1000px"
            :before-close="clearadddata"
        >
            <el-form
                ref="addform"
                :model="addform"
                :rules="rules"
                label-width="110px"
                style="position: relative"
            >
                <el-form-item label-width="180px" label="姓名：" prop="name">
                    <el-input
                        :disabled="readyOnly"
                        v-model="addform.name"
                        style="width: 50%"
                    ></el-input>
                </el-form-item>
                <el-form-item label-width="180px" label="性别：" prop="sex">
                    <el-select
                        :disabled="readyOnly"
                        v-model="addform.sex"
                        placeholder="--请选择--"
                        style="width: 50%"
                    >
                        <el-option label="男" value="0"></el-option>
                        <el-option label="女" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label-width="180px"
                    label="身份证号："
                    prop="idCode"
                >
                    <el-input
                        :disabled="readyOnly"
                        v-model="addform.idCode"
                        style="width: 50%"
                    ></el-input>
                </el-form-item>
                <!-- <el-form-item label="年龄：" prop="age">
          <el-input
            :disabled="readyOnly"
            v-model.number="addform.age"
            style="width: 50%"
          ></el-input>
        </el-form-item> -->
                <el-form-item
                    label-width="180px"
                    label="手机号码："
                    prop="phone"
                >
                    <el-input
                        :disabled="readyOnly"
                        v-model.number="addform.phone"
                        style="width: 50%"
                    ></el-input>
                </el-form-item>
                <el-form-item label-width="180px" label="所属组织：">
                    <el-select
                        :disabled="readyOnly"
                        style="width: 50%"
                        v-model="addform.consultOrgId"
                    >
                        <el-option
                            v-for="(item, index) in consultOrgList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label-width="180px"
                    label="类别："
                    prop="parentPersonTypeId"
                >
                    <el-checkbox-group
                        v-model="checkedCities"
                        @change="handleCheckedCitiesChange"
                    >
                        <el-checkbox
                            :disabled="readyOnly"
                            v-for="item in cities"
                            :label="item.id"
                            :key="item.id"
                            :value="item.id"
                            >{{ item.consultName }}</el-checkbox
                        >
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item prop="photoPath" class="zjimg">
                    <div class="threestyleimg">
                        <div class="threestyleimgtu">
                            <img
                                :src="eddimgurl"
                                alt
                                style="width: 170px; height: 200px"
                            />
                        </div>
                        <div class="threestyleimgbtn">
                            <div>专家照片</div>
                            <input type="file" @change="upimg" />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    label-width="180px"
                    label="是否是社区工作人员："
                    prop="communityPerson"
                >
                    <el-radio-group
                        :disabled="readyOnly"
                        v-model="addform.communityPerson"
                    >
                        <el-radio label="0">是</el-radio>
                        <el-radio label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label-width="180px" label="状态：" prop="status">
                    <el-radio-group
                        :disabled="readyOnly"
                        v-model="addform.status"
                    >
                        <el-radio label="0">启用</el-radio>
                        <el-radio label="1">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <template v-if="showType == 'audit'">
                    <el-form-item label-width="180px" label="审批结果: ">
                        <el-radio-group v-model="addform.approvalStatus">
                            <el-radio label="1">同意</el-radio>
                            <el-radio label="2">不同意</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label-width="180px" label="审批意见: ">
                        <el-input
                            type="textarea"
                            :rows="4"
                            placeholder="请输入内容"
                            v-model="addform.approvalOpinion"
                        ></el-input>
                    </el-form-item>
                </template>
                <template
                    v-if="
                        showType == 'detail' && addform.approvalStatus !== '0'
                    "
                >
                    <el-form-item label-width="180px" label="审批结果: ">
                        <el-radio-group v-model="addform.approvalStatus">
                            <el-radio label="1" disabled>同意</el-radio>
                            <el-radio label="2" disabled>不同意</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label-width="180px" label="审批意见: ">
                        <el-input
                            disabled
                            type="textarea"
                            :rows="4"
                            placeholder="请输入内容"
                            v-model="addform.approvalOpinion"
                        ></el-input>
                    </el-form-item>
                </template>
            </el-form>
            <div
                class="boontbtn"
                v-show="showType == 'edit' || showType == 'add'"
            >
                <el-button
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="addformClick"
                    >保存</el-button
                >
                <el-button type="info" size="small" @click="clearadddata"
                    >关闭</el-button
                >
            </div>
            <div class="boontbtn" v-if="showType == 'audit'">
                <el-button
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="saveAuditdata"
                    >保存</el-button
                >
                <el-button type="info" size="small" @click="clearadddata"
                    >取消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import { log } from "util"
import echarts_msg from "../../../utils/echarts.js"
import request from "../../../utils/request.js"
import { getTypeById_p, getConsulTYpePersion } from "@/api/http.js"
import upimg from "@/components/uploadImg/index.vue"
let token = JSON.parse(window.localStorage.getItem("user"))
import { quillEditor } from "vue-quill-editor"
import editor_option from "@/utils/editorOption.js"
import { post } from "@/api/requrestHttp"
import { uploadPartyPhoto } from "@/api/http"
import baseURL from "@/api/baseURL"
export default {
    data() {
        return {
            url:baseURL+
                "/ypt/controller/uploadVotePic/info/uploadPartyPhoto",
            checkedCities: [],
            cities: [],
            // 富文本配置
            editorOption: editor_option.editorOption,
            dialogTitle: "新增",
            dialogImageUrl: "", //图片上传,
            dialogVisible1: false, // 上传模态框按钮
            // 新增弹出层
            showadd: false,
            checkList: [],
            showDisabled: false,
            checkedList: [],
            organization: "",
            addform: {
                photoPath: "",
                photoPath: "",
                parentPersonTypeId: "", //人员大类类别
                personTypeId: "", // 人员小类类别
                consultType: "",
                name: "",
                sex: "",
                numberId: "",
                phone: "",
                resume: "",
                enclosure: "",
                status: "",
                orgLevel: "",
            },
            consultOrgList: [],
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur",
                        trigger: "blur",
                    },
                ],
                sex: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "blur",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur",
                    },
                    {
                        validator: function (rule, value, callback) {
                            if (/^1[34578]\d{9}$/.test(value) == false) {
                                callback(new Error("请输入正确的手机号"))
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur",
                    },
                ],
                idCode: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: "blur",
                    },
                    {
                        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                        message: "你的身份证格式不正确",
                    },
                ],
                photoPath: [
                    { required: false, message: "请上传照片", trigger: "blur" },
                ],
                communityPerson: [
                    {
                        required: true,
                        message: "请选择是否是社区工作人员",
                        trigger: "change",
                    },
                ],
                status: [
                    {
                        required: true,
                        message: "请选择启动状态",
                        trigger: "change",
                    },
                ],
            },
            //弹出框审核
            showaudit: false,
            searchlist: {},
            fileListimg: [],
            //专业
            searchTypes: [],
            //人员类别
            searchGroups: [],
            searchGroupsChild: [],
            //维护时需转换的字段
            fileList: [],
            majors: [],
            //表格数据
            tableData: [],
            eddimgurl: require("../../../assets/images/partyMemberManagementcopy/imgjia.png"),
            // 分页配置
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
            readyOnly: false,
            showType: "",
            uploadUrl: request.defaults.baseURL + "/consulType/info/uplodfile",
            uploadMoreUrl:
                request.defaults.baseURL + "/consulType/info/uplodfiles",
            parentPersonTypeId: "",
        }
    },
    computed: {},
    methods: {
        findConsultPersonTypeList() {
            post("/admin/consultPersonType/info/findConsultPersonTypeList", {
                pageNo: 1,
                pageSize: 100,
                status: 0,
            }).then((res) => {
                console.log(res.content.list)
                res.content.list.forEach((item) => {
                    console.log(item.consultName)
                    this.cities.push(item)
                })
                console.log(this.cities)
            })
        },
        handleCheckedCitiesChange(value) {
            // console.log(value);
            this.parentPersonTypeId = value
            console.log(this.parentPersonTypeId)
            // let checkedCount = value.length;
            // this.checkAll = checkedCount === this.cities.length;
            // this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
        },
        //条件查询
        searchlistdata() {
            this.pageConfig.pageNo = 1
            this.getPageDatas()
        },
        searchlistReset() {
            this.searchlist = {}
            this.pageConfig.pageNo = 1
            this.getPageDatas()
        },
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getPageDatas()
        },
        //每页展示条数
        handleSizeChange(val) {
            //console.log(`每页 ${val} 条`);
            this.pageConfig.pageSize = val
            this.pageConfig.pageNo = 1
            this.getPageDatas()
        },
        //获取列表数据
        async getPageDatas() {
            var res = await getConsulTYpePersion({
                ...this.pageConfig,
                ...this.searchlist,
                menuType: "personInformationBase",
            })
            if (res.code == 200) {
                // console.log(">>>>>>", res);
                this.pageConfig.total = res.content.count
                this.tableData = res.content.list
            } else {
                console.log(res)
                this.$message({
                    message: "数据加载异常：",
                    type: "error",
                })
            }
        },
        //改变状态
        async changeStatus(cdata) {
            let params = {
                id: cdata.id,
                status: cdata.status,
            }
            console.log(params)
            post("admin/consulType/info/updateConsultPerson", params).then(
                (res) => {
                    console.log(res)
                    var msg = "状态"
                    msg = msg + (cdata.status == "0" ? "启用" : "禁用")
                    if (res.code == 200) {
                        this.$message({
                            message: msg + "成功",
                            type: "success",
                        })
                    } else {
                        console.log(res.message)
                        this.$message({
                            message: msg + "失败",
                            type: "error",
                        })
                    }
                }
            )
        },
        //改变状态
        async personTypeChange(ids) {
            let res = await getTypeById_p({
                parentId: ids,
                pageSize: 9999,
                pageNo: 1,
            })
            if (res.content) {
                this.searchGroupsChild = res.content.list || []
            }
        },
        async showDialogForm(id, flag) {
            //编辑
            this.organization = ""
            this.eddimgurl = require("../../../assets/images/partyMemberManagementcopy/imgjia.png")
            this.getConsuOrgLlist()
            this.showType = flag
            if (id != "") {
                if (flag == "edit") {
                    this.dialogTitle = "编辑"
                    this.showadd = true
                    this.readyOnly = false
                } else if (flag == "detail") {
                    this.dialogTitle = "查看"
                    //   this.showDisabled = true;
                    //   this.showaudit = true;
                    this.showadd = true
                    this.readyOnly = true
                } else if (flag == "audit") {
                    this.dialogTitle = "审批"
                    //   this.showDisabled = false;
                    //   this.showaudit = true;
                    this.showadd = true
                    this.readyOnly = true
                }
                //获取编辑项的最新数据
                let fd = new FormData()
                fd.append("token", token)
                fd.append("id", id)
                var res = await request({
                    url: "/admin/consulType/info/findConsultPersonById",
                    method: "POST",
                    data: fd,
                })
                // console.log(res)
                if (res.code == 200) {
                    res.content.phone = Number(res.content.phone)
                    if (flag == "audit") {
                        res.content.approvalOpinion =
                            res.content.approvalOpinion || ""
                        res.content.approvalStatus = res.content.approvalStatus
                            ? res.content.approvalStatus
                            : "1"
                    }
                    this.addform = res.content
                    var arr = []
                    if (this.addform.photoPath) {
                        this.eddimgurl = this.addform.photoPath
                    } else {
                        this.eddimgurl = require("../../../assets/images/partyMemberManagementcopy/imgjia.png")
                    }
                    console.log("打开--", this.checkedCities)
                    this.checkedCities = []
                    var aaa = this.addform.parentPersonTypeId.split(",")
                    aaa.forEach((item) => {
                        this.checkedCities.push(Number(item))
                    })
                    console.log("打开--", this.checkedCities)
                    // this.checkedCities = Array.from(new Set(this.checkedList));
                    // console.log(this.checkedCities);

                    this.fileList = []
                    var temp = {}
                    if (res.content.enclosurePath) {
                        var namesArr = []
                        if (res.content.enclosureName) {
                            namesArr = res.content.enclosureName.split(",")
                        }

                        var enclosureArr = res.content.enclosurePath.split(",")
                        enclosureArr.forEach((item, index) => {
                            if (item != "") {
                                temp = {
                                    name: namesArr[index]
                                        ? namesArr[index]
                                        : "附件" + index,
                                    url: item,
                                }
                                this.fileList.push(temp)
                            }
                        })
                    }
                } else {
                    //   console.log(res.code + "：" + res.message);
                    this.$message({
                        message: "数据加载异常",
                        type: "error",
                    })
                    this.showadd = false
                    this.showaudit = false
                }
            } else {
                this.showadd = true
                this.dialogTitle = "新增"
                // console.log(this.$refs.addform);
                this.addform = {}
                if (this.$refs.addform) {
                    this.$refs.addform.resetFields()
                }
            }
        },
        handleExceed(files, fileList) {
            var selected = files.length
            var totalselected = selected + fileList.length
            this.$message.warning(
                "当前限制选择3个文件，本次选择了" +
                    selected +
                    "个文件，共选择了" +
                    totalselected +
                    "个文件"
            )
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2
            // if (!isJPG) {
            //   this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!")
            }
            return isLt2M
        },
        // 上传图片
        async upimg(e) {
            if (e.target.files[0] == undefined) {
                return false
            } else {
                let res = await uploadPartyPhoto(e.target.files[0])
                this.eddimgurl = res.content
            }
        },
        uploadSuccess(response, file, fileList) {
            // console.log(response)
            if (
                response.code == 200 &&
                response.content != "" &&
                response.content != null
            ) {
                this.addform.photoName = response.content.name
                this.addform.photoPath = response.content.path
            }
        },
        //确保每次只能上传一个文件，可多次上传
        uploadSuccessMore(response, file, fileList) {
            if (
                response.code == 200 &&
                response.content != "" &&
                response.content != null
            ) {
                this.fileList.push({
                    name: response.content.name,
                    url: response.content.path,
                })
            }
        },
        handleRemove(file, fileList) {
            this.fileList = fileList
        },
        //附件预览
        handlePreview(file) {
            window.open(file.url)
        },
        addformClick() {
            this.$refs.addform.validate((valid) => {
                if (valid) {
                    this.saveadddata()
                } else {
                    return false
                }
            })
        },
        getConsuOrgLlist() {
            post("/admin/consulOrg/info/listConsultOrg", {
                pageSize: 9999,
                pageNo: 1,
                status: 0,
            }).then((res) => {
                if (res.code == 200) {
                    this.consultOrgList = res.content.list
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // getOrgLevel() {
        //   post("admin/user/info/getLoginUserInfo", {
        //     id: this.$store.status.id,
        //   }).then((res) => {
        //     if (res.code == 200) {
        //       // this.userName=res.content.user.name;
        //       this.orgLevel = res.content.user.orgLevel;
        //     } else {
        //       this.$message.error(res.message);
        //     }
        //   });
        // },
        //获取新增所有数据发请求
        async saveadddata() {
            this.parentPersonTypeId = this.parentPersonTypeId + ""
            this.$set(
                this.addform,
                "parentPersonTypeId",
                this.parentPersonTypeId
            )
            // this.$set(this.addform, "consultOrgId", this.organization);
            this.$set(this.addform, "photoPath", this.eddimgurl)
            console.log(this.addform.parentPersonTypeId)
            //对多选的专业进行数组转字符串
            if (this.majors.length > 0) {
                this.addform.major = this.majors.join("/")
            }
            if (this.fileList.length > 0) {
                this.addform.enclosurePath = ""
                this.addform.enclosureName = ""
                this.fileList.forEach((item) => {
                    this.addform.enclosurePath =
                        this.addform.enclosurePath + "," + item.url
                    this.addform.enclosureName =
                        this.addform.enclosureName + "," + item.name
                })
            }
            let params = this.addform
            if (params == "{}") {
                this.$message({
                    message: "保存数据为空",
                    type: "error",
                })
                return false
            }
            console.log(params)
            var res = await request({
                url: "/admin/consulType/info/insertConsultPerson",
                method: "POST",
                data: params,
            })
            if (res.code == 200) {
                this.$message({
                    message: this.dialogTitle + "成功",
                    type: "success",
                })
                this.showadd = false
                this.pageConfig.pageNo = 1
                this.getPageDatas()
                this.clearadddata()
            } else {
                console.log(res)
                this.$message({
                    message: this.dialogTitle + "失败：" + res.message,
                    type: "error",
                })
            }
            if (this.orgLevel == 3) {
                this.saveAuditdata()
            }
        },
        //上传图片方法
        handleRemove2(file, fileList) {
            this.add.photoPath.map((item, index) => {
                if (file.response != undefined) {
                    if (item == file.response.content) {
                        this.add.photoPath.splice(index, 1)
                    }
                } else {
                    if (item == file.url) {
                        this.add.photoPath.splice(index, 1)
                    }
                }
            })
        },
        handlePictureCardPreview2(file) {
            this.dialogImageUrl = file.url
            this.dialogVisible1 = true
        },
        imgok: function (data, data1, data2) {
            if (data.code == 200) {
                this.add.photoPath.push(data.content)
            }
        },
        //审批接口
        async saveAuditdata() {
            if (!this.addform.approvalStatus) {
                this.$message({
                    message: "保存数据为空",
                    type: "error",
                })
                return false
            }
            if (
                this.addform.approvalStatus == "2" &&
                this.addform.approvalOpinion == ""
            ) {
                this.$message({
                    message: "请填写不通过原因",
                    type: "error",
                })
                return false
            }
            let fd = new FormData()
            fd.append("token", token)
            let params = JSON.stringify({
                id: this.addform.id,
                approvalStatus: this.addform.approvalStatus,
                approvalOpinion: this.addform.approvalOpinion,
            })
            fd.append("ConsultPerson", params)
            console.log(params)
            var res = await request({
                url: "/admin/consulType/info/approvalConsultPerson",
                method: "POST",
                data: fd,
            })
            if (res.code == 200) {
                this.$message({
                    message: res.message,
                    type: "success",
                })
                // this.showaudit = false;
                this.showadd = false
                this.pageConfig.pageNo = 1
                this.getPageDatas()
            } else {
                console.log(res)
                this.$message({
                    message: res.message,
                    type: "error",
                })
            }
        },
        // 新增弹出框重置
        clearadddata() {
            this.showadd = false
            this.checkedCities = []
        },
        //根据身份证号码截取出生年月
        fullBirthday() {
            if (this.addform.numberId != undefined) {
                let iden = this.addform.numberId
                let birth = ""
                if (iden.length === 18) {
                    birth =
                        iden.substring(6, 10) +
                        "-" +
                        iden.substring(10, 12) +
                        "-" +
                        iden.substring(12, 14)
                }
                if (iden.length === 15) {
                    birth =
                        "19" +
                        iden.substring(6, 8) +
                        "-" +
                        iden.substring(8, 10) +
                        "-" +
                        iden.substring(10, 12)
                }
                this.$set(this.addform, "birthday", birth)
            }
        },
        // 图表加载函数
        async drawChart() {
            let fd = new FormData()
            fd.append("token", token)
            var res = await request({
                url: "/admin/consulType/info/personStatistics",
                method: "POST",
                data: fd,
            })
            if (res.code == 200) {
                // console.log(res.content)
                //按人员类别查看
                var option_1_1_text = []
                var option_1_1_data = []
                if (res.content.personType) {
                    res.content.personType.forEach((item, index) => {
                        option_1_1_text.push(item.typeName)
                        option_1_1_data.push(item.number)
                    })
                }
                let myChart_l_1 = this.$echarts.init(
                    document.getElementById("chart_1_1")
                )
                var option_1_1 = echarts_msg.option_bar
                option_1_1.title.text = ""
                option_1_1.xAxis.type = "category"
                option_1_1.xAxis.data = option_1_1_text
                option_1_1.yAxis.type = "value"
                option_1_1.series[0].itemStyle.normal.color = new this.$echarts.graphic.LinearGradient(
                    1,
                    0,
                    1,
                    1,
                    [
                        { offset: 0, color: "#45b6e75c" },
                        { offset: 1, color: "#45b6e7 " },
                    ]
                )
                option_1_1.series[0].data = option_1_1_data
                myChart_l_1.setOption(option_1_1)

                //专业人士专业分布 柱状图
                var option_1_2_text = []
                var option_1_2_data = []
                if (res.content.major) {
                    res.content.major = res.content.major.filter(
                        (it) => !!it.majorName
                    )
                    res.content.major.forEach((item) => {
                        option_1_2_text.push(item.majorName)
                        option_1_2_data.push(item.number)
                    })
                }

                let myChart_1_2 = this.$echarts.init(
                    document.getElementById("chart_1_2")
                )
                var option_1_2 = echarts_msg.option_bar
                option_1_2.title.text = ""
                option_1_2.xAxis.type = "value"
                option_1_2.xAxis.data = []
                option_1_2.yAxis.type = "category"
                option_1_2.yAxis.data = option_1_2_text
                option_1_2.series[0].itemStyle.normal.color = new this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    1,
                    0,
                    [
                        { offset: 0, color: "#ff8383" },
                        { offset: 1, color: "#ffe5e6 " },
                    ]
                )
                option_1_2.series[0].data = option_1_2_data
                myChart_1_2.setOption(option_1_2)

                // 按性别查看 饼状图
                var option_1_3_text = []
                var option_1_3_data = []
                if (res.content.sex) {
                    res.content.sex.forEach((item) => {
                        option_1_3_text.push(item.sexName)
                        option_1_3_data.push({
                            value: item.number,
                            name: item.sexName,
                        })
                    })
                }
                let myChart_1_3 = this.$echarts.init(
                    document.getElementById("chart_1_3")
                )
                var option_1_3 = echarts_msg.option_pie
                option_1_3.title.text = ""
                option_1_3.legend.data = option_1_3_text
                option_1_3.series[0].data = option_1_3_data
                myChart_1_3.setOption(option_1_3)

                let sizeFun = function () {
                    myChart_l_1.resize()
                    myChart_1_2.resize()
                    myChart_1_3.resize()
                }
                window.addEventListener("resize", sizeFun)
            } else {
                console.log(res)
                this.$message({
                    message: "统计图加载异常：",
                    type: "error",
                })
            }
        },
        //删除操作
        async showdeletepanduan(id) {
            this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let fd = new FormData()
                    fd.append("token", token)
                    fd.append("id", id)
                    var res = await request({
                        url: "/admin/consulType/info/deleteConsultPerson",
                        method: "POST",
                        data: fd,
                    })
                    if (res.code == 200) {
                        this.$message({
                            message: "删除成功",
                            type: "success",
                        })
                        this.showadd = false
                        this.pageConfig.pageNo = 1
                        this.getPageDatas()
                    } else {
                        console.log(res)
                        this.$message({
                            message: "删除失败：" + res.message,
                            type: "error",
                        })
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    })
                })
        },
        // //获取条件查询的一级分类
        // async getPTypes() {
        //   let fd = new FormData();
        //   fd.append("token", token);
        //   let params = JSON.stringify({ parentId: 0 });
        //   fd.append("consultType", params);
        //   var res = await request({
        //     url: "/admin/consulType/info/findConsultType",
        //     method: "POST",
        //     data: fd
        //   });
        //   var temp = {};
        //   // this.searchTypes.push(temp);
        //   if (res.content.length > 0) {
        //     res.content.forEach(item => {
        //       temp = { value: item.consultName, label: item.consultName };
        //       this.searchTypes.push(temp);
        //     });
        //   }
        //   //默认写死
        //   this.searchGroups = [
        //     { value: "1", label: "两委代表" },
        //     { value: "2", label: "两新代表" },
        //     { value: "3", label: "专业人士" }
        //   ];
        // },
        //获取人员类别树状图
        async getPTypes() {
            var res = await getTypeById_p({
                pageNo: 1,
                pageSize: 9999,
                parentId: 0,
            })
            //   console.log(res);

            if (res.content) {
                this.searchGroups = res.content.list || []
            }
        },
        formatterPersonType(row, column) {
            return row.parentPersonTypeName
        },
        formatterPersonType1(row, column) {
            return row.personTypeName
        },
    },
    mounted() {
        // 初始化图表加载
        this.drawChart()
        this.getPTypes()
        this.getPageDatas()
        this.findConsultPersonTypeList()
    },

    watch: {
        showadd(val) {
            if (!val) {
                // this.readyOnly = false;
                this.readyOnly = false
                this.showType = ""
                this.majors = ""
                this.fileList = []
                this.addform.personTypeId = ""
                this.$refs.addform.resetFields()
                // this.addform = {
                //   photoPath: ""
                // };
            }
        },
    },
    components: {
        upimg,
        quillEditor,
    },
}
</script>

<style lang="less" scoped>
//  包裹两个卡片的盒子
.card-box {
    display: flex;
    // 左边树状列表卡片
    .card-l {
        width: 270px;
    }
    .card-r {
        // overflow: hidden;
        flex: 1;
        height: 320px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .card-0 {
            width: 32.5%;
            height: 320px;
            .onebuttom {
                height: 258px;
                div {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .card-2 {
            width: 32.5%;
            height: 320px;
            .onebuttom {
                height: 258px;
                // background-color: red;
                div {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .card-3 {
            width: 32.5%;
            height: 320px;
            .onebuttom {
                height: 258px;
                div {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .topbarnav {
            display: flex;
            align-items: center;
            div {
                box-sizing: border-box;
                padding: 0 10px;
                font-size: 14px;
            }
        }
    }
}
.card-4 {
    margin-top: 12px;
}
// 表格的盒子
.table_card {
    // overflow: hidden;
    // 解决表格无法自适应宽度
    // width: calc(100vw - 500px);
    margin: 16px 0 0 0;
    .el-table {
        width: 100%;
        // 表格里的按钮
        .tabBtn {
            margin: 0 6px;
        }
        .tabBtn:nth-child(1) {
            color: #199b5d;
            font-size: 22px;
        }
        .tabBtn:nth-child(2) {
            color: #ff04ed;
            // font-size: 25px;
        }
        .tabBtn:nth-child(3) {
            color: #dd3020;
            // font-size: 25px;
        }
        .tabBtn:nth-child(5) {
            color: #e400ff;
            font-size: 22px;
        }
        .tabBtn:nth-child(4) {
            color: #2e99cf;
            // font-size: 25px;
        }
        .active_Btn {
            color: #ff04ed !important;
            // font-size: 25px;
        }
    }
}

.download {
    .color {
        height: 25px;
        line-height: 25px;
        padding-left: 20px;
        background-color: #cdcdcd;
    }
    p {
        margin: 10px 0 10px 0;
        padding-left: 20px;
        a {
            color: #01aaef;
        }
    }
}
.threestyleimg {
    display: flex;
    // align-items: center;
    // justify-content: center;
    flex-wrap: wrap;
    .threestyleimgtu {
        width: 80%;
        height: 70%;
        // background-color: red;
        display: flex;
        // justify-content: center;
        // align-items: center;
    }
    .threestyleimgbtn {
        width: 80%;
        height: 30%;
        // background-color: green;
        display: flex;
        // justify-content: center;
        // align-items: center;

        position: relative;
        div {
            width: 170px;
            height: 30%;
            background: #ffffff;
            border: 1px solid #cad4dc;
            text-align: center;
            line-height: 30px;
        }
        input {
            position: absolute;
            width: 172px;
            height: 32px;
            opacity: 0;
            cursor: pointer;
        }
    }
}
</style>
<style lang="less">
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.zjimg {
    position: absolute;
    top: -15px;
    right: -35px;
}
.threestyleimg {
    display: flex;
    // align-items: center;
    // justify-content: center;
    flex-wrap: wrap;
    .threestyleimgtu {
        width: 80%;
        height: 70%;
        // background-color: red;
        display: flex;
        // justify-content: center;
        // align-items: center;
    }
    .threestyleimgbtn {
        width: 80%;
        height: 30%;
        margin-top: 20px;

        // background-color: green;
        display: flex;
        // justify-content: center;
        // align-items: center;

        position: relative;
        div {
            width: 170px;
            height: 30%;
            background: #ffffff;
            border: 1px solid #cad4dc;
            text-align: center;
            line-height: 30px;
        }
        input {
            position: absolute;
            width: 172px;
            height: 32px;
            opacity: 0;
            cursor: pointer;
        }
    }
}
.el-form-item {
    margin-top: 25px;
}
</style>